import React from 'react';

interface SkipIconProps {
	className?: string;
}

export const SkipIcon = ({ className }: SkipIconProps) => (
	<svg width="38" height="28" className={className} viewBox="0 0 38 28" fill="#BAC5D5" xmlns="http://www.w3.org/2000/svg">
		<path d="M18.2946 12.0563C19.6284 13.0552 19.6284 15.1745 18.2946 16.1734L3.67591 27.1215C2.12591 28.2823 -2.20574e-05 27.0918 -2.19748e-05 25.0629L-2.10832e-05 3.16673C-2.10006e-05 1.13788 2.12591 -0.0526773 3.67592 1.10814L18.2946 12.0563Z" />
		<path d="M36.9996 12.4001C38.3335 13.399 38.3335 15.5183 36.9996 16.5172L22.381 27.4653C20.831 28.6262 18.7051 27.4356 18.7051 25.4068L18.7051 3.51054C18.7051 1.48169 20.831 0.291134 22.381 1.45195L36.9996 12.4001Z" />
	</svg>
);
